import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KpaLayoutComponent } from './kpa-layout.component';
import { KpaLayoutRoutingModule } from './kpa-layout.routing';
import { SharedModule } from '@app/shared/shared.module';
import { DashboardModule } from '@app/dashboard/dashboard.module';
import { SdsModule } from '@app/sds/sds.module';
import { AnnouncementsModule } from '@app/announcements/announcements.module';

@NgModule({
	declarations: [KpaLayoutComponent],
	imports: [DashboardModule, SdsModule, AnnouncementsModule, SharedModule, KpaLayoutRoutingModule, CommonModule],
})
export class KpaLayoutModule {}
